import { render, staticRenderFns } from "./cat_timestamp.vue?vue&type=template&id=345d99a9&scoped=true&"
import script from "./cat_timestamp.vue?vue&type=script&lang=ts&"
export * from "./cat_timestamp.vue?vue&type=script&lang=ts&"
import style0 from "./cat_timestamp.vue?vue&type=style&index=0&id=345d99a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d99a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
